import { render, staticRenderFns } from "./agentplane-chat.vue?vue&type=template&id=5dd31630&scoped=true"
import script from "./agentplane-chat.vue?vue&type=script&lang=js"
export * from "./agentplane-chat.vue?vue&type=script&lang=js"
import style0 from "./agentplane-chat.vue?vue&type=style&index=0&id=5dd31630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd31630",
  null
  
)

export default component.exports